function scrollTo(id){
  try {
    const el = document.getElementById(id);
    if(!el) throw Error(`Element With id="${id}" Not Found`);
    el.scrollIntoView({ behavior: "smooth" });
  } catch(err) {
    console.log(err);
  }
}

export default scrollTo;